import { render } from "./Manage_3.vue?vue&type=template&id=2a34412c&scoped=true"
import script from "./Manage_3.vue?vue&type=script&lang=js"
export * from "./Manage_3.vue?vue&type=script&lang=js"

import "./Manage_3.vue?vue&type=style&index=0&id=2a34412c&lang=css"
import "./Manage_3.vue?vue&type=style&index=1&id=2a34412c&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a34412c"]])

export default __exports__